/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import './api';
import '../bizbank/service';
import '../beemo/v2/reporting/settlements';
import './model';
import '../banking/common';
import '../common/time';
import '../banking/account_model';
import '../instant-deposit/instant_deposits';
import '../simple_instrument_store/model';
import '../bills/tender';
import '../bizbank/unified_activity';
import '../ledger/deposit_settings';
import '../instant-deposit/dashboard_service';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "deposits": {
        "nested": {
          "service": {
            "nested": {
              "GetBalanceSummaryRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeRecentActivity": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "applyFeeRateToWithdrawalAmount": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "GetBalanceSummaryResponse": {
                "fields": {
                  "balance": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instantDepositDetails": {
                    "type": "squareup.deposits.service.InstantDepositDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "linkedBankAccount": {
                    "type": "squareup.deposits.BankAccountInfo",
                    "id": 9,
                    "rule": "optional"
                  },
                  "linkedCard": {
                    "type": "squareup.deposits.service.CardInfo",
                    "id": 4,
                    "rule": "optional"
                  },
                  "squareCard": {
                    "type": "squareup.bizbank.service.CardData",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "allowPartialDeposit": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cardActivity": {
                    "type": "squareup.bizbank.service.CardActivity",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "depositActivity": {
                    "type": "squareup.deposits.service.GetBalanceSummaryResponse.DepositActivity",
                    "id": 8,
                    "rule": "optional"
                  },
                  "eligibilityDetails": {
                    "type": "squareup.deposits.service.EligibilityDetails",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "balanceInformation": {
                    "type": "squareup.deposits.service.GetBalanceSummaryResponse.BalanceInformation",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DepositActivity": {
                    "fields": {
                      "activeSalesReport": {
                        "type": "squareup.beemo.api.v2.reporting.SettlementReportWrapper",
                        "id": 1,
                        "rule": "optional"
                      },
                      "pendingDeposit": {
                        "type": "squareup.beemo.api.v2.reporting.SettlementReportWrapper",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "BalanceInformation": {
                    "fields": {
                      "totalBalance": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "availableBalance": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "pendingBalance": {
                        "type": "squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "balanceType": {
                        "type": "squareup.deposits.BalanceType",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetBalanceStatusRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceStatusResponse": {
                "fields": {
                  "viewCapability": {
                    "type": "squareup.deposits.service.GetBalanceStatusResponse.ViewCapability",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "eligibleBalanceActivity": {
                    "type": "squareup.deposits.BalanceActivityType",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "ViewCapability": {
                    "values": {
                      "UNKNOWN_VIEW_CAPABILITY_DO_NOT_USE": 0,
                      "UNIFIED_ACTIVITY": 1,
                      "CARD_UPSELL": 2,
                      "CARD_SPEND_REPORT": 3,
                      "DIRECT_DEPOSIT_ACCOUNT": 4,
                      "SPEND_VISUALIZATION": 5
                    }
                  }
                }
              },
              "ListBalancesRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListBalancesResponse": {
                "fields": {
                  "balanceSummaries": {
                    "type": "squareup.deposits.service.ListBalancesResponse.BalanceSummary",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "BalanceSummary": {
                    "fields": {
                      "balanceId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "balanceType": {
                        "type": "squareup.deposits.BalanceType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "availableBalance": {
                        "type": "squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "state": {
                        "type": "squareup.banking.AccountState",
                        "id": 5,
                        "rule": "optional"
                      },
                      "supportedBalanceActivities": {
                        "type": "squareup.deposits.BalanceActivityType",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "supportedBalanceTransferDestinationTypes": {
                        "type": "squareup.deposits.BalanceType",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "pendingSettlementTime": {
                        "type": "squareup.common.time.DateTime",
                        "id": 8,
                        "rule": "optional"
                      },
                      "balanceOwnershipToken": {
                        "type": "squareup.deposits.BalanceOwnershipToken",
                        "id": 9,
                        "rule": "optional"
                      },
                      "accountMetadata": {
                        "type": "squareup.banking.AccountMetadata",
                        "id": 10,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetEligibleInstrumentsRequest": {
                "fields": {
                  "activityType": {
                    "type": "squareup.deposits.BalanceActivityType",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "EligibleInstrumentsForActivity": {
                "fields": {
                  "activityType": {
                    "type": "squareup.deposits.BalanceActivityType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instrument": {
                    "type": "squareup.deposits.InstrumentView",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "availableAction": {
                    "type": "squareup.deposits.service.EligibleInstrumentsForActivity.AvailableInstrumentAction",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "eligibleInstrumentActionState": {
                    "type": "squareup.deposits.service.EligibleInstrumentsForActivity.EligibleInstrumentActionState",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AvailableInstrumentAction": {
                    "values": {
                      "UNKNOWN_AVAILABLE_ACTION_DO_NOT_USE": 0,
                      "LINK_BANK_ACCOUNT": 1,
                      "LINK_DEBIT_CARD": 2,
                      "RESEND_CONFIRMATION_MESSAGE": 3,
                      "CANCEL_VERIFICATION": 4
                    }
                  },
                  "EligibleInstrumentActionState": {
                    "values": {
                      "UNKNOWN_ELIGIBLE_ACTION_STATE_DO_NOT_USE": 0,
                      "ELIGIBLE": 1,
                      "ACTION_REQUIRED": 2,
                      "UNSUPPORTED": 3
                    }
                  }
                }
              },
              "GetEligibleInstrumentsResponse": {
                "fields": {
                  "eligibleInstrumentsForActivity": {
                    "type": "squareup.deposits.service.EligibleInstrumentsForActivity",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "EligibilityDetails": {
                "fields": {
                  "activityType": {
                    "type": "squareup.deposits.BalanceActivityType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "blocker": {
                    "type": "squareup.deposits.EligibilityBlocker",
                    "id": 2,
                    "rule": "optional"
                  },
                  "minAmount": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "maxAmount": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "eligibilityStatus": {
                    "type": "squareup.deposits.LocalizedStatusMessage",
                    "id": 6,
                    "rule": "optional"
                  },
                  "primaryInstrument": {
                    "type": "squareup.deposits.InstrumentView",
                    "id": 7,
                    "rule": "optional"
                  },
                  "primaryInstrumentChanged": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "fee": {
                    "type": "squareup.ledger.service.FeeStructure",
                    "id": 9,
                    "rule": "optional"
                  },
                  "staticDailyLimit": {
                    "type": "squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "InstantDepositDetails": {
                "fields": {
                  "eligibilityBlocker": {
                    "type": "squareup.ledger.service.EligibilityBlocker",
                    "id": 1,
                    "rule": "optional"
                  },
                  "maxDepositAmount": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "showPriceChangeModal": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "showInstrumentChangedScreen": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "primaryInstrument": {
                    "type": "squareup.simple_instrument_store.Instrument.Type",
                    "id": 6,
                    "rule": "optional"
                  },
                  "maxDepositFeeAmount": {
                    "type": "squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "CardInfo": {
                "fields": {
                  "brand": {
                    "type": "squareup.bills.CardTender.Card.Brand",
                    "id": 1,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "supportsInstantDeposit": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "instrumentToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "CreateTransferRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "balanceActivityType": {
                    "type": "squareup.deposits.BalanceActivityType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "source": {
                    "type": "squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 5,
                    "rule": "optional"
                  },
                  "destination": {
                    "type": "squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 6,
                    "rule": "optional"
                  },
                  "clientIp": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": "squareup.deposits.TransferMetadata",
                    "id": 9,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": "squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "isWithdrawalFromBalanceAmount": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "applyFeeRateToWithdrawalAmount": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "CreateTransferResponse": {
                "fields": {
                  "statusMessage": {
                    "type": "squareup.deposits.LocalizedStatusMessage",
                    "id": 3,
                    "rule": "optional"
                  },
                  "balanceActivity": {
                    "type": "squareup.deposits.BalanceActivity",
                    "id": 1
                  },
                  "failure": {
                    "type": "squareup.deposits.BalanceActivityFailure",
                    "id": 2
                  }
                },
                "nested": {
                  "result": {
                    "oneof": ["balanceActivity", "failure"]
                  }
                }
              },
              "GetEligibilityDetailsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "activityType": {
                    "type": "squareup.deposits.BalanceActivityType",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "GetEligibilityDetailsResponse": {
                "fields": {
                  "eligibilityDetails": {
                    "type": "squareup.deposits.service.EligibilityDetails",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetMerchantTransferTagsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetMerchantTransferTagsResponse": {
                "fields": {
                  "unitTransferTags": {
                    "type": "squareup.deposits.service.GetMerchantTransferTagsResponse.TransferTagsResponse",
                    "id": 1,
                    "keyType": "string"
                  }
                },
                "nested": {
                  "TransferTagsResponse": {
                    "fields": {
                      "transferTag": {
                        "type": "string",
                        "id": 1
                      },
                      "error": {
                        "type": "squareup.deposits.service.GetMerchantTransferTagsResponse.TransferTagsResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "INVALID_UNIT_TOKEN": 1,
                          "UNKNOWN_ERROR": 2
                        }
                      },
                      "result": {
                        "oneof": ["transferTag", "error"]
                      }
                    }
                  }
                }
              },
              "SetMerchantTransferTagsRequest": {
                "fields": {
                  "merchantAndTransferTag": {
                    "type": "squareup.deposits.service.SetMerchantTransferTagsRequest.MerchantAndTransferTag",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "MerchantAndTransferTag": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "transferTag": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SetMerchantTransferTagsResponse": {
                "fields": {
                  "setTransferTagFailure": {
                    "type": "squareup.deposits.service.SetMerchantTransferTagsResponse.SetTransferTagFailure",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "SetTransferTagFailure": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "error": {
                        "type": "squareup.deposits.service.SetMerchantTransferTagsResponse.SetTransferTagFailure.Error",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "CONTAINS_DISALLOWED_CHAR": 1,
                          "CONTAINS_PROFANITY": 2,
                          "TOO_LONG": 3,
                          "UNKNOWN_ERROR": 4
                        }
                      }
                    }
                  }
                }
              },
              "GetPendingActivitiesRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetPendingActivitiesResponse": {
                "fields": {
                  "pendingActivities": {
                    "type": "squareup.deposits.service.GetPendingActivitiesResponse.PendingActivities",
                    "id": 1,
                    "keyType": "string"
                  }
                },
                "nested": {
                  "PendingActivities": {
                    "fields": {
                      "activities": {
                        "type": "squareup.deposits.service.GetPendingActivitiesResponse.PendingActivity",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "PendingActivity": {
                    "fields": {
                      "amount": {
                        "type": "squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "occurredAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      },
                      "activityState": {
                        "type": "squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                        "id": 6,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "balanceActivityType": {
                        "type": "squareup.deposits.BalanceActivityType",
                        "id": 4
                      },
                      "activityType": {
                        "type": "squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                        "id": 5
                      }
                    },
                    "nested": {
                      "type": {
                        "oneof": ["balanceActivityType", "activityType"]
                      }
                    }
                  }
                }
              },
              "GetTransferFeeDetailsRequest": {
                "fields": {
                  "sourceId": {
                    "type": "squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "destinationId": {
                    "type": "squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferType": {
                    "type": "squareup.deposits.BalanceActivityType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "withdrawalAmount": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "GetTransferFeeDetailsResponse": {
                "fields": {
                  "sourceId": {
                    "type": "squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "destinationId": {
                    "type": "squareup.deposits.BalanceActivityEntityIdentifier",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferType": {
                    "type": "squareup.deposits.BalanceActivityType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "withdrawalAmount": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transferAmount": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "feeAmount": {
                    "type": "squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "feeBasisPoints": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "ExternalDepositsService": {
                "methods": {
                  "GetDepositSchedule": {
                    "requestType": "squareup.ledger.service.GetDepositScheduleRequest",
                    "responseType": "squareup.ledger.service.GetDepositScheduleResponse"
                  },
                  "SetDepositSchedule": {
                    "requestType": "squareup.ledger.service.SetDepositScheduleRequest",
                    "responseType": "squareup.ledger.service.SetDepositScheduleResponse"
                  },
                  "GetBalanceStatus": {
                    "requestType": "squareup.deposits.service.GetBalanceStatusRequest",
                    "responseType": "squareup.deposits.service.GetBalanceStatusResponse"
                  },
                  "GetBalanceSummary": {
                    "requestType": "squareup.deposits.service.GetBalanceSummaryRequest",
                    "responseType": "squareup.deposits.service.GetBalanceSummaryResponse"
                  },
                  "GetEligibleInstruments": {
                    "requestType": "squareup.deposits.service.GetEligibleInstrumentsRequest",
                    "responseType": "squareup.deposits.service.GetEligibleInstrumentsResponse"
                  },
                  "GetInstantDepositSettlementDetail": {
                    "requestType": "squareup.ledger.service.GetInstantDepositSettlementDetailRequest",
                    "responseType": "squareup.ledger.service.GetInstantDepositSettlementDetailResponse"
                  },
                  "CreateTransfer": {
                    "requestType": "squareup.deposits.service.CreateTransferRequest",
                    "responseType": "squareup.deposits.service.CreateTransferResponse"
                  },
                  "GetEligibilityDetails": {
                    "requestType": "squareup.deposits.service.GetEligibilityDetailsRequest",
                    "responseType": "squareup.deposits.service.GetEligibilityDetailsResponse"
                  },
                  "EligibleForInstantDeposit": {
                    "requestType": "squareup.ledger.service.EligibleForInstantDepositRequest",
                    "responseType": "squareup.ledger.service.EligibleForInstantDepositResponse"
                  },
                  "GetMerchantTransferTags": {
                    "requestType": "squareup.deposits.service.GetMerchantTransferTagsRequest",
                    "responseType": "squareup.deposits.service.GetMerchantTransferTagsResponse"
                  },
                  "SetMerchantTransferTags": {
                    "requestType": "squareup.deposits.service.SetMerchantTransferTagsRequest",
                    "responseType": "squareup.deposits.service.SetMerchantTransferTagsResponse"
                  },
                  "GetPendingActivities": {
                    "requestType": "squareup.deposits.service.GetPendingActivitiesRequest",
                    "responseType": "squareup.deposits.service.GetPendingActivitiesResponse"
                  },
                  "ListBalances": {
                    "requestType": "squareup.deposits.service.ListBalancesRequest",
                    "responseType": "squareup.deposits.service.ListBalancesResponse"
                  },
                  "GetTransferFeeDetails": {
                    "requestType": "squareup.deposits.service.GetTransferFeeDetailsRequest",
                    "responseType": "squareup.deposits.service.GetTransferFeeDetailsResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceSummaryRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceSummaryResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceSummaryResponse?.nested?.DepositActivity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceSummaryResponse?.nested?.BalanceInformation && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceStatusRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceStatusResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetBalanceStatusResponse?.nested?.ViewCapability && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListBalancesRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListBalancesResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ListBalancesResponse?.nested?.BalanceSummary && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetEligibleInstrumentsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.EligibleInstrumentsForActivity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.EligibleInstrumentsForActivity?.nested?.AvailableInstrumentAction && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.EligibleInstrumentsForActivity?.nested?.EligibleInstrumentActionState && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetEligibleInstrumentsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.EligibilityDetails && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.InstantDepositDetails && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CardInfo && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CreateTransferRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.CreateTransferResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetEligibilityDetailsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetEligibilityDetailsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetMerchantTransferTagsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetMerchantTransferTagsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetMerchantTransferTagsResponse?.nested?.TransferTagsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetMerchantTransferTagsResponse?.nested?.TransferTagsResponse?.nested?.Error && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsRequest?.nested?.MerchantAndTransferTag && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsResponse?.nested?.SetTransferTagFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.SetMerchantTransferTagsResponse?.nested?.SetTransferTagFailure?.nested?.Error && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetPendingActivitiesRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetPendingActivitiesResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetPendingActivitiesResponse?.nested?.PendingActivities && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetPendingActivitiesResponse?.nested?.PendingActivity && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetTransferFeeDetailsRequest && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.GetTransferFeeDetailsResponse && !$root.nested?.squareup?.nested?.deposits?.nested?.service?.nested?.ExternalDepositsService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetBalanceSummaryRequest @ squareup/deposits/service.proto at 35:1
 */
export const GetBalanceSummaryRequest = $root.lookupType('squareup.deposits.service.GetBalanceSummaryRequest');
fixType(GetBalanceSummaryRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBalanceSummaryRequest);
/**
 * SOURCE GetBalanceSummaryResponse @ squareup/deposits/service.proto at 52:1
 */
export const GetBalanceSummaryResponse = $root.lookupType('squareup.deposits.service.GetBalanceSummaryResponse');
fixType(GetBalanceSummaryResponse, {
  balance: {
    required: true
  },
  instantDepositDetails: {
    required: true
  },
  allowPartialDeposit: {
    required: true
  },
  balanceInformation: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceSummaryResponse);
/**
 * SOURCE DepositActivity @ squareup/deposits/service.proto at 77:3
 */
GetBalanceSummaryResponse.DepositActivity = $root.lookupType('squareup.deposits.service.GetBalanceSummaryResponse.DepositActivity');
fixType(GetBalanceSummaryResponse.DepositActivity);
Builder.createAndAttachToType(GetBalanceSummaryResponse.DepositActivity);
/**
 * SOURCE BalanceInformation @ squareup/deposits/service.proto at 91:3
 */
GetBalanceSummaryResponse.BalanceInformation = $root.lookupType('squareup.deposits.service.GetBalanceSummaryResponse.BalanceInformation');
fixType(GetBalanceSummaryResponse.BalanceInformation, {
  totalBalance: {
    required: true
  }
});
Builder.createAndAttachToType(GetBalanceSummaryResponse.BalanceInformation);
/**
 * SOURCE GetBalanceStatusRequest @ squareup/deposits/service.proto at 108:1
 */
export const GetBalanceStatusRequest = $root.lookupType('squareup.deposits.service.GetBalanceStatusRequest');
fixType(GetBalanceStatusRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBalanceStatusRequest);
/**
 * SOURCE GetBalanceStatusResponse @ squareup/deposits/service.proto at 112:1
 */
export const GetBalanceStatusResponse = $root.lookupType('squareup.deposits.service.GetBalanceStatusResponse');
fixType(GetBalanceStatusResponse);
Builder.createAndAttachToType(GetBalanceStatusResponse);
/**
 * SOURCE ViewCapability @ squareup/deposits/service.proto at 113:3
 */
GetBalanceStatusResponse.ViewCapability = $root.lookupEnum('squareup.deposits.service.GetBalanceStatusResponse.ViewCapability').values;
/**
 * SOURCE ListBalancesRequest @ squareup/deposits/service.proto at 159:1
 */
export const ListBalancesRequest = $root.lookupType('squareup.deposits.service.ListBalancesRequest');
fixType(ListBalancesRequest);
Builder.createAndAttachToType(ListBalancesRequest);
/**
 * SOURCE ListBalancesResponse @ squareup/deposits/service.proto at 164:1
 */
export const ListBalancesResponse = $root.lookupType('squareup.deposits.service.ListBalancesResponse');
fixType(ListBalancesResponse);
Builder.createAndAttachToType(ListBalancesResponse);
/**
 * Simplified generic view of a balance's current state.
 *
 * SOURCE BalanceSummary @ squareup/deposits/service.proto at 166:3
 */
ListBalancesResponse.BalanceSummary = $root.lookupType('squareup.deposits.service.ListBalancesResponse.BalanceSummary');
fixType(ListBalancesResponse.BalanceSummary);
Builder.createAndAttachToType(ListBalancesResponse.BalanceSummary);
/**
 * SOURCE GetEligibleInstrumentsRequest @ squareup/deposits/service.proto at 202:1
 */
export const GetEligibleInstrumentsRequest = $root.lookupType('squareup.deposits.service.GetEligibleInstrumentsRequest');
fixType(GetEligibleInstrumentsRequest, {
  activityType: {
    required: true
  },
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetEligibleInstrumentsRequest);
/**
 * SOURCE EligibleInstrumentsForActivity @ squareup/deposits/service.proto at 207:1
 */
export const EligibleInstrumentsForActivity = $root.lookupType('squareup.deposits.service.EligibleInstrumentsForActivity');
fixType(EligibleInstrumentsForActivity, {
  activityType: {
    required: true
  }
});
Builder.createAndAttachToType(EligibleInstrumentsForActivity);
/**
 * SOURCE AvailableInstrumentAction @ squareup/deposits/service.proto at 208:3
 */
EligibleInstrumentsForActivity.AvailableInstrumentAction = $root.lookupEnum('squareup.deposits.service.EligibleInstrumentsForActivity.AvailableInstrumentAction').values;
/**
 * SOURCE EligibleInstrumentActionState @ squareup/deposits/service.proto at 225:3
 */
EligibleInstrumentsForActivity.EligibleInstrumentActionState = $root.lookupEnum('squareup.deposits.service.EligibleInstrumentsForActivity.EligibleInstrumentActionState').values;
/**
 * SOURCE GetEligibleInstrumentsResponse @ squareup/deposits/service.proto at 256:1
 */
export const GetEligibleInstrumentsResponse = $root.lookupType('squareup.deposits.service.GetEligibleInstrumentsResponse');
fixType(GetEligibleInstrumentsResponse);
Builder.createAndAttachToType(GetEligibleInstrumentsResponse);
/**
 * SOURCE EligibilityDetails @ squareup/deposits/service.proto at 265:1
 */
export const EligibilityDetails = $root.lookupType('squareup.deposits.service.EligibilityDetails');
fixType(EligibilityDetails);
Builder.createAndAttachToType(EligibilityDetails);
/**
 * SOURCE InstantDepositDetails @ squareup/deposits/service.proto at 303:1
 */
export const InstantDepositDetails = $root.lookupType('squareup.deposits.service.InstantDepositDetails');
fixType(InstantDepositDetails);
Builder.createAndAttachToType(InstantDepositDetails);
/**
 * SOURCE CardInfo @ squareup/deposits/service.proto at 333:1
 */
export const CardInfo = $root.lookupType('squareup.deposits.service.CardInfo');
fixType(CardInfo, {
  brand: {
    required: true
  },
  panSuffix: {
    notEmpty: true
  },
  supportsInstantDeposit: {
    required: true
  }
});
Builder.createAndAttachToType(CardInfo);
/**
 * SOURCE CreateTransferRequest @ squareup/deposits/service.proto at 438:1
 */
export const CreateTransferRequest = $root.lookupType('squareup.deposits.service.CreateTransferRequest');
fixType(CreateTransferRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  amount: {
    required: true
  },
  balanceActivityType: {
    required: true
  }
});
Builder.createAndAttachToType(CreateTransferRequest);
/**
 * SOURCE CreateTransferResponse @ squareup/deposits/service.proto at 492:1
 */
export const CreateTransferResponse = $root.lookupType('squareup.deposits.service.CreateTransferResponse');
fixType(CreateTransferResponse);
Builder.createAndAttachToType(CreateTransferResponse);
/**
 * SOURCE GetEligibilityDetailsRequest @ squareup/deposits/service.proto at 635:1
 */
export const GetEligibilityDetailsRequest = $root.lookupType('squareup.deposits.service.GetEligibilityDetailsRequest');
fixType(GetEligibilityDetailsRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetEligibilityDetailsRequest);
/**
 * SOURCE GetEligibilityDetailsResponse @ squareup/deposits/service.proto at 641:1
 */
export const GetEligibilityDetailsResponse = $root.lookupType('squareup.deposits.service.GetEligibilityDetailsResponse');
fixType(GetEligibilityDetailsResponse);
Builder.createAndAttachToType(GetEligibilityDetailsResponse);
/**
 * SOURCE GetMerchantTransferTagsRequest @ squareup/deposits/service.proto at 670:1
 */
export const GetMerchantTransferTagsRequest = $root.lookupType('squareup.deposits.service.GetMerchantTransferTagsRequest');
fixType(GetMerchantTransferTagsRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetMerchantTransferTagsRequest);
/**
 * SOURCE GetMerchantTransferTagsResponse @ squareup/deposits/service.proto at 674:1
 */
export const GetMerchantTransferTagsResponse = $root.lookupType('squareup.deposits.service.GetMerchantTransferTagsResponse');
fixType(GetMerchantTransferTagsResponse);
Builder.createAndAttachToType(GetMerchantTransferTagsResponse);
/**
 * SOURCE TransferTagsResponse @ squareup/deposits/service.proto at 675:3
 */
GetMerchantTransferTagsResponse.TransferTagsResponse = $root.lookupType('squareup.deposits.service.GetMerchantTransferTagsResponse.TransferTagsResponse');
fixType(GetMerchantTransferTagsResponse.TransferTagsResponse);
Builder.createAndAttachToType(GetMerchantTransferTagsResponse.TransferTagsResponse);
/**
 * SOURCE Error @ squareup/deposits/service.proto at 676:5
 */
GetMerchantTransferTagsResponse.TransferTagsResponse.Error = $root.lookupEnum('squareup.deposits.service.GetMerchantTransferTagsResponse.TransferTagsResponse.Error').values;
/**
 * SOURCE SetMerchantTransferTagsRequest @ squareup/deposits/service.proto at 690:1
 */
export const SetMerchantTransferTagsRequest = $root.lookupType('squareup.deposits.service.SetMerchantTransferTagsRequest');
fixType(SetMerchantTransferTagsRequest);
Builder.createAndAttachToType(SetMerchantTransferTagsRequest);
/**
 * SOURCE MerchantAndTransferTag @ squareup/deposits/service.proto at 691:3
 */
SetMerchantTransferTagsRequest.MerchantAndTransferTag = $root.lookupType('squareup.deposits.service.SetMerchantTransferTagsRequest.MerchantAndTransferTag');
fixType(SetMerchantTransferTagsRequest.MerchantAndTransferTag, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SetMerchantTransferTagsRequest.MerchantAndTransferTag);
/**
 * SOURCE SetMerchantTransferTagsResponse @ squareup/deposits/service.proto at 699:1
 */
export const SetMerchantTransferTagsResponse = $root.lookupType('squareup.deposits.service.SetMerchantTransferTagsResponse');
fixType(SetMerchantTransferTagsResponse);
Builder.createAndAttachToType(SetMerchantTransferTagsResponse);
/**
 * SOURCE SetTransferTagFailure @ squareup/deposits/service.proto at 700:3
 */
SetMerchantTransferTagsResponse.SetTransferTagFailure = $root.lookupType('squareup.deposits.service.SetMerchantTransferTagsResponse.SetTransferTagFailure');
fixType(SetMerchantTransferTagsResponse.SetTransferTagFailure, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(SetMerchantTransferTagsResponse.SetTransferTagFailure);
/**
 * SOURCE Error @ squareup/deposits/service.proto at 703:5
 */
SetMerchantTransferTagsResponse.SetTransferTagFailure.Error = $root.lookupEnum('squareup.deposits.service.SetMerchantTransferTagsResponse.SetTransferTagFailure.Error').values;
/**
 * SOURCE GetPendingActivitiesRequest @ squareup/deposits/service.proto at 765:1
 */
export const GetPendingActivitiesRequest = $root.lookupType('squareup.deposits.service.GetPendingActivitiesRequest');
fixType(GetPendingActivitiesRequest);
Builder.createAndAttachToType(GetPendingActivitiesRequest);
/**
 * SOURCE GetPendingActivitiesResponse @ squareup/deposits/service.proto at 769:1
 */
export const GetPendingActivitiesResponse = $root.lookupType('squareup.deposits.service.GetPendingActivitiesResponse');
fixType(GetPendingActivitiesResponse);
Builder.createAndAttachToType(GetPendingActivitiesResponse);
/**
 * SOURCE PendingActivities @ squareup/deposits/service.proto at 770:3
 */
GetPendingActivitiesResponse.PendingActivities = $root.lookupType('squareup.deposits.service.GetPendingActivitiesResponse.PendingActivities');
fixType(GetPendingActivitiesResponse.PendingActivities);
Builder.createAndAttachToType(GetPendingActivitiesResponse.PendingActivities);
/**
 * SOURCE PendingActivity @ squareup/deposits/service.proto at 779:3
 */
GetPendingActivitiesResponse.PendingActivity = $root.lookupType('squareup.deposits.service.GetPendingActivitiesResponse.PendingActivity');
fixType(GetPendingActivitiesResponse.PendingActivity);
Builder.createAndAttachToType(GetPendingActivitiesResponse.PendingActivity);
/**
 * SOURCE GetTransferFeeDetailsRequest @ squareup/deposits/service.proto at 987:1
 */
export const GetTransferFeeDetailsRequest = $root.lookupType('squareup.deposits.service.GetTransferFeeDetailsRequest');
fixType(GetTransferFeeDetailsRequest, {
  transferType: {
    required: true
  }
});
Builder.createAndAttachToType(GetTransferFeeDetailsRequest);
/**
 * SOURCE GetTransferFeeDetailsResponse @ squareup/deposits/service.proto at 995:1
 */
export const GetTransferFeeDetailsResponse = $root.lookupType('squareup.deposits.service.GetTransferFeeDetailsResponse');
fixType(GetTransferFeeDetailsResponse, {
  transferType: {
    required: true
  },
  feeBasisPoints: {
    required: true
  }
});
Builder.createAndAttachToType(GetTransferFeeDetailsResponse);
/**
 * SOURCE ExternalDepositsService @ squareup/deposits/service.proto at 1279:1
 */
export const ExternalDepositsService = $root.lookupService('squareup.deposits.service.ExternalDepositsService');